import { Button, Col, Row } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';

import FilterItem from './FilterItem';
import FilterPopover from './FilterPopover';
import FilterSection from './FilterSection';
import styles from './FilterToolbar.module.css';

interface FilterToolbarProps {
  onClear?: () => void;
  children: React.ReactNode[];
}

const FilterToolbar = ({ onClear, children }: FilterToolbarProps) => {
  //Works only for Sections with multiple FilterItem
  const selectedFromSections = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && child.type === FilterSection) {
      //Scan for FilterItem children and return them
      return child.props?.children
        ?.filter(({ type, props }: React.ReactElement) => type === FilterItem && props.selected)
        .map(({ props }: React.ReactElement) => props.selected);
    }

    return null;
  });

  const selected = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && child.type === FilterItem && child.props.selected) {
      return child.props.selected;
    }

    return null;
  });
  const selecteds = [...(selected || []), ...(selectedFromSections || [])];

  return (
    <Row className={styles.row} gutter={[8, 16]}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child) && child.type === FilterItem) {
          const { alwaysOn = false, flex, span, ...props } = child.props;

          if (alwaysOn) {
            return (
              <Col flex={flex} span={span}>
                <FilterPopover {...props} />
              </Col>
            );
          }

          return null;
        }

        return child;
      })}
      {selecteds && selecteds.length > 0 && (
        <Col span={24} data-testid="toolbar-tags-container">
          {selecteds}
          {onClear && (
            <Button data-testid="toolbar-clear-filters" size="small" onClick={() => onClear()}>
              <Trans>Limpar filtros</Trans>
            </Button>
          )}
        </Col>
      )}
    </Row>
  );
};

export default FilterToolbar;
